import React from 'react'

import i18n from 'i18n-literally'

import CancelIcon from '@mui/icons-material/Cancel'
import { Box } from '@mui/material'

import createLogger from '~/src/Lib/Logging'
import { PUBLIC_ROUTES, REGISTER_ROUTES } from '~/src/Routes/constants'
import Button from '~/src/UI/Shared/Button'
import T from '~/src/UI/Shared/Typography'

const displayName = 'SuccessGateway'
const logger = createLogger(displayName)

const AccountCreationError = () => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap="2rem">
    <CancelIcon sx={{ width: 50, height: 50 }} color="error" />
    <Box textAlign="center">
      <T.H2>{i18n`Oops!`}</T.H2>
      <T>{i18n`Something went wrong`}</T>
    </Box>
    <Box maxWidth={400} textAlign="center" display="flex" flexDirection="column">
      <T>{i18n`It could be that another user has activated the Gateway already on a new account.`}</T>
      <T.Body.Bold textAlign="center">{i18n`You can start the process again or ask the admin to be a user on the account.`}</T.Body.Bold>
    </Box>
    <Box display="flex" justifyContent="space-between">
      <Button variant="text" href={PUBLIC_ROUTES.HOME}>
        {i18n`Exit`}
      </Button>
      <Button href={REGISTER_ROUTES.GATEWAY}>
        {i18n`Start over`}
      </Button>
    </Box>
  </Box>
)

const Memoized = React.memo(AccountCreationError)
export default Memoized
